export default "__VITE_ASSET__Ca7GhO_V__"